import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../components/elements/Loader';
import { authHeader, tableHeadersFields } from '../../../../utils';
import axios from 'axios';
import { ERROR } from '../../../../store/types';
import { useParams } from 'react-router-dom';
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet';
import StudentStatus from '../../../../components/elements/StudentStatus';
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon';
import DataTable from '../../../../components/elements/DataTable';
import ModalDialog from '../../../../components/layouts/ModalDialog';
import NewSundryTransaction from '../../../../components/partials/sundry/NewSundryTransaction';
import { clearCreatedSundryTransaction } from '../../../../store/actions/sundriesActions';
import moment from 'moment';
import TransactionType from '../../../../components/elements/TransactionType';
import SundryTransactionDetails from '../../../../components/partials/sundry/SundryTransactionDetails';

const SundryAccountDetails = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [sundryAccountDetails, setSundryAccountDetails] = useState(null)
  const {accountId} = useParams()
  const sundriesSelector = useSelector(state => state.sundries)

  useEffect(() => {
    const getAccountDetails = async () => {
      try {
        const headers = authHeader()
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/sundries/sundry-accounts/${accountId}?expand=student`, { headers })            

        setSundryAccountDetails(response.data.data)
        setLoading(false)
      } catch (error) {
        console.log(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoading(false)
      }
    }

    getAccountDetails()

    if(sundriesSelector.createdSundryTransaction !== null){
      setRecordingTransaction(false)
      dispatch(clearCreatedSundryTransaction())
    }

    return () => {
      
    };
  }, [accountId, dispatch, sundriesSelector.createdSundryTransaction]);

  const [transactions, setTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);

  useEffect(() => {
    const getAccountTransactions = async () => {
      try {
        const headers = authHeader()
        setLoadingTransactions(true)
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/sundries/sundry-transactions/account/${accountId}?expand=recordedBy,items.item&page=${page}&perPage=${perPage}`, { headers })            

        setTransactions(response.data.data)
        setLoadingTransactions(false)
      } catch (error) {
        console.log(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoadingTransactions(false)
      }
    }

    getAccountTransactions()

    return () => {
      
    };
  }, [accountId, dispatch, page, perPage, sundriesSelector.createdSundryTransaction]);

  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{openTransactionDetails(transactions.transactions[index])}
  }

  const columnDataStyles = {}

  const transactionColumnWidths = {
    reference: 'w-2/12',
    type: 'w-1/12',
    remarks: 'w-3/12',
    recordedBy: 'w-2/12',
    amount: 'w-2/12',
    timeStamp: 'w-2/12',
  }

  const cleanupData = (dataSet) => {
    if(!dataSet) return []

    const data = []

    dataSet.forEach((item, itemIndex) => {
      data.push(
        {
          reference: item.reference.toUpperCase(),
          amount: <p className='font-space-grotesk font-[500] text-md'>₦{(item.amount/100).toLocaleString()}</p>,
          type: <div className='-mt-[7px]'><TransactionType type={item.type} /></div>,
          recordedBy: item.recordedBy?.fullName || <div className='h-[14px] w-[120px] bg-gray-200 animate-pulse' />,
          remarks: <p className='text-gray-500'>{item.remarks || ''}</p>,
          timeStamp: <p>
            {moment(item.createdAt).format('MMMM Do YYYY')}<br />
            <span className='text-xs text-gray-500'>{moment(item.createdAt).format('h:mm A')}</span></p>
        },
      )
    })

    return data
  }

  const [recordingTransaction, setRecordingTransaction] = useState(false);

  const [activeTransaction, setActiveTransaction] = useState(null)
  const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false)

  const openTransactionDetails = (transaction) => {
    console.log(transaction)
    setActiveTransaction(transaction)
    setTimeout(() => {
      setTransactionDetailsOpen(true)
    }, 200);
  }

  const closeTransaction = () => {
    setTransactionDetailsOpen(false)
    setTimeout(() => {
      setActiveTransaction(null)
    }, 200);
  }

  return (
    <>
      <div className='w-full'>
        {loading 
          ?
          <Loader />
          :
          <>
            <div className='w-full flex items-start gap-x-[20px]'>
              <div className='w-4/12'>
                <div className='w-full bg-gray-50 rounded-[8px] py-[30px]'>
                  <div className='mt-[60px] px-[20px]'>
                    <label className='text-gray-400 text-xs font-[550]'>Sundry Balance</label>
                    <h1 className='text-xl font-[550] text-gray-800 tracking-[0.2em]'>₦{(sundryAccountDetails.balance/100).toLocaleString()}</h1>
                  </div>

                  <div className='flex items-center justify-between w-full pt-[15px] px-[20px] mt-[20px] border-t gap-x-[10px]'>
                    <div className=''>
                      <label className='text-gray-400 text-xs'>Total Funding</label>
                      <div className='flex items-center gap-x-[5px]'>
                        <ArrowIcon className={`w-3 h-3 text-green-500 rotate-90`} />
                        <h1 className='text-sm font-[500] text-gray-500'>₦{(sundryAccountDetails.funding?.totalAmount/100)?.toLocaleString() || 0} <span className='text-gray-400 font-400 text-[12px] font-outfit'>({sundryAccountDetails.funding?.totalTransactions?.toLocaleString()} transactions)</span></h1>
                      </div>
                    </div>
                    <div className=''>
                      <label className='text-gray-400 text-xs'>Total Expenses</label>
                      <div className='flex items-center gap-x-[5px]'>
                        <ArrowIcon className={`w-3 h-3 text-red-500 -rotate-90`} />
                        <h1 className='text-sm font-[500] text-gray-500'>₦{(sundryAccountDetails.expenses?.totalAmount/100)?.toLocaleString() || 0} <span className='text-gray-400 font-400 text-[12px] font-outfit'>({sundryAccountDetails.expenses?.totalTransactions?.toLocaleString()} transactions)</span></h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-4/12'>
                <div className='my-[20px]'>
                  <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Account Reference</label>
                  <p className='font-space-grotesk font-[500] tracking-[0.2em]'>{sundryAccountDetails?.reference}</p>
                </div>

                <div className='my-[20px]'>
                  <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Account Status</label>
                  <StudentStatus status={sundryAccountDetails?.active ? 'ACTIVE' : 'INACTIVE'} />
                </div>

                <div className='my-[20px]'>
                  <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Account Owner</label>
                  <ApplicantTableSnippet applicant={sundryAccountDetails?.student} />
                </div>
              </div>
            </div>

            <div className='w-full mt-[40px] pt-[40px] border-t'>
              <div className='w-full flex items-center justify-between'>
                <div className='w-2/3'>
                    <h4 className='font-medium text-lg mb-1 text-gray-400'>Sundry Account transactions</h4>
                    <div className=''>
                        <p className='text-gray-500 mt-1 text-sm'>
                            Below is a list of transactions for this account
                        </p>
                    </div>
                </div>
                <button onClick={()=>{setRecordingTransaction(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    Record a Transaction
                </button>
              </div>
            </div>

            <div className='mt-[20px]'>
              {loadingTransactions 
              ? 
                <div className='w-full'>
                    <Loader />
                </div>
              : 
                <DataTable
                    tableHeaders={tableHeadersFields(cleanupData(transactions?.transactions)[0]).headers} 
                    tableData={cleanupData(transactions?.transactions)} 
                    columnWidths={transactionColumnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanupData(transactions?.transactions)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage, 
                        currentPage: page,
                        totalItems: transactions.total,
                    }}
                    changePage={setPage}
                    updatePerPage={setPerPage}
                />
              }
            </div>
          </>
        }
      </div>

      <ModalDialog
        shown={recordingTransaction} 
        closeFunction={()=>{setRecordingTransaction(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Record a sundry transaction for ${sundryAccountDetails?.student?.firstName} ${sundryAccountDetails?.student?.lastName}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <NewSundryTransaction 
          account={sundryAccountDetails}
          close={()=>{setRecordingTransaction(false)}}
        />
      </ModalDialog>


    {activeTransaction && <ModalDialog
        shown={transactionDetailsOpen} 
        closeFunction={()=>{closeTransaction()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Sundry Transaction - ${activeTransaction?.reference}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
       <SundryTransactionDetails transaction={activeTransaction} />
      </ModalDialog>}
    </>
  )
}

export default SundryAccountDetails